module.exports = __webpack_public_path__ + "d6576e469db5a258452d00cc7df09dee.fbx";